<template>
    <div class="all">
        <div class="screen">
            <h2 class="ovhidden">{{eventName}}</h2>
            <p class="mt10">{{startDate}} ~ {{endDate}}</p>
        </div>
        <div class="screen mt20">
            <div class="item clearfix">
                <span class="zu clearfix">
                    <span class="d-flex">
				        <span class="name">媒体类别</span>
                        <platTypeCascader title="媒体类别" :industryTypeList="mediaLevelList" :morenzhi="morenzhi" @putData="getPlanvalue"></platTypeCascader>
				    </span>
                </span>
                <span class="zu clearfix">
                    <span class="name">排序方式</span>
                    <span class="drop-down">
                        <button class="btn btn-lightblue"><span class="texts">{{paixu[sort]}}</span><i class="icons"></i></button>
                        <ul class="option">
                            <li v-for="(item,index) in paixu" :key="index"  @click="dropDownSelect(3,index)">{{item}}</li>
                        </ul>
                    </span>
                </span>
                <span class="zu clearfix">
                    <span class="name">发布地区</span>
                    <city ref="cityWarp" @cityCallback="citySelect" levels="3"></city>
                </span>
            </div>
            <div class="item clearfix">
                <div class="fl">
                    <span class="name">情感属性</span>
                    <div class="screen-list">
                        <label class="checkbox-box" v-for="(item,index) in emotionList" :key="index">
                            <label class="checkbox-warp fl" :class="emotion.indexOf(item) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="emotion" name="" type="checkbox" :value="item">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            {{item}}
                        </label>
                    </div>
                </div>
                <div class="search-warp fr clearfix">
                    <span class="drop-down fl">
                        <button class="btn search-dropdown"><span class="text">{{searchText[searchType]}}</span><i class="icons"></i></button>
                        <ul class="option">
                            <li v-for="(item,index) in searchText" @click="searchSelect(index);" :key="index">{{item}}</li>
                        </ul>
                    </span>
                    <button class="search-btn fr" @click="KeyUpEsc"><i class="icons search-icon"></i></button> 
                    <div class="hidden"><input type="text" v-model.trim="keywords" @keyup.enter="KeyUpEsc" :placeholder="searchPlaceholder[searchType]" class="input-text"></div>
                </div>
            </div>
            <div class="item clearfix">
                <span class="zu clearfix">
                    <span class="name">时间范围</span>
                    <div class="clearfix fl">
                        <div class="corm fl">
                            <a class="element" :class="{curr:timeType===5}" href="javascript:void(0)" @click="selectFixedTime(5);">24小时</a>
                            <a class="element" :class="{curr:timeType===0}" href="javascript:void(0)" @click="selectFixedTime(0);">今天</a>
                            <a class="element" :class="{curr:timeType===1}" href="javascript:void(0)" @click="selectFixedTime(1);">昨天</a>
                            <a class="element" :class="{curr:timeType===2}" href="javascript:void(0)" @click="selectFixedTime(2);">近三天</a>
                            <a class="element" :class="{curr:timeType===3}" href="javascript:void(0)" @click="selectFixedTime(3);">近七天</a>
                            <a class="element" :class="{curr:timeType===4 || timeType===6}" href="javascript:void(0)" @click="selectFixedTime(4);">自定义</a>
                        </div>
                        <vue-datepicker-local v-if="timeType === 4 || timeType===6" class="fl" v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" show-buttons :disabledDate="disabledDate"  @confirm="selectedDate"/>
                    </div>
                </span>
            </div>
            <div class="item mt10 clearfix">
                <span class="name">媒体类型</span>
                <div class="screen-list">
                    <label class="checkbox-box" v-for="(item,index) in MediaPlatformList" :key="index">
                        <label class="checkbox-warp fl">
                            <input class="checkbox" v-model="platformType" name="" type="checkbox" :value="index">
                            <i class="icons checkbox-icon"></i>
                        </label>
                        {{item.name}} <span class="color-8a8a99">({{item.num}})</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="warp mt20">
            <div class="warp-header">
                <div class="firle clearfix">
                    <div class="fl">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="uuids.length === pageUuid.length && uuids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false" @click="checkAll($event)" type="checkbox" value="0">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <!-- <span class="checkbox-box tion">删除</span> -->
                        <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" @click="downLoad(2);" title="下载当前方案的所有数据">全部下载</span>
                    </div>
                </div>
            </div>
            <div class="warp-body clearfix">
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <ul class="article-list mtfu24">
                    <li v-for="(item,index) in newsList" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox" :value="item.newsId">
                                <i class="icons checkbox-icon"></i>
                            </label>     
                        </div> 
                        <div class="article-right fr">
                            <div class="article-btn">
                                <span class="collect" @click="collectFn(index);" :class="item.collectStatus === 0 ? '' : 'curr'"><i class="icons collect-icon"></i></span>
                                <span class="sign sign-blue cp" @click="oneClickCopy(index)">复</span>
                            </div>  
                        </div> 
                        <div class="article-mid">
							<h2 class="article-title clearfix">
								<div class="title ovhidden fl" :class="{difference:item.platform === 'comment'}">
									<span class="tag" :class="$parent.attributeType[item.newsEmotion]">{{item.newsEmotion}}</span>
									<router-link class="color-3d3d4c" target="_blank" :to="{path:'/detailInformation',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}" v-html="item.newsTitle" :title="item.newsTitle"></router-link>
								</div>
								<div class="fu fl" v-if="item.platform === 'comment'">
									<span class="color-red fs12">评</span>
								</div>
							</h2>
							<p class="ovhidden2 color-8a8a99" :title="item.newsDigest" v-html="item.newsDigest"></p>
                            <p class="ziduan color-8a8a99 mt10">
                                <span>时间：{{item.newsPosttime}}</span>
                                <!-- <span>相似文章：<router-link class="color-blue" target="_blank" :to="{path:''+$parent.baseUrl+'/similarArticles',query: {id:item.newsId}}" :class="item.simNum === '' ? 'load-sm' : ''">{{item.simNum}}</router-link></span> -->
                                <!-- <span>相似文章：<i class="color-blue" :class="item.simNum === '' ? 'load-sm' : ''">{{item.simNum}}</i></span> -->
                                <span>发布平台：<i class="icons sm-icon" :class="icons[item.platform]"></i>{{item.platformName}}</span>
                                <span>发布人：{{item.mediaName}}</span>
                                <span v-if="item.mediaProvince != ''">发布地区：{{item.mediaProvince}}</span>
                                <span>分析词：<i :class="item.keywords == '' ? 'load-sm' : ''"></i>{{item.keywords}}</span>
                                <!-- <span v-if="item.mediaLevel != ''">媒体等级：{{item.mediaLevel}}</span> -->
                            </p>
                        </div> 
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <div class="checkbox-group nolike clearfix">
                    <h4 v-if="downloadTips != ''">tips:<span class="color-red">{{downloadTips}}</span></h4>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="selectOptionValue.length === selectOption.length ? 'curr' : ''"><input name="" :checked="selectOptionValue.length === selectOption.length ? true : false" type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item,index) in selectOption" :key="index">
                        <label class="checkbox-warp fl" :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name="" v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 一键复制 -->
		<copy ref="copy" :text="copyHtml"></copy>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import Dialog from '@/components/dialog.vue'
import platTypeCascader from '../../components/platTypeCascader.vue';
import VueDatepickerLocal from 'vue-datepicker-local'
import city from '@/components/city.vue';
import page from '@/components/page.vue';
import copy from '@/components/copy.vue';
export default {
    components:{VueDatepickerLocal,city,page,Dialog,copy,platTypeCascader},
    computed:{
        ...mapState({
            mediaLevelList: state => state.show.companyinfo.mediaLevelList
        })
    },
    data() {
        const min = ''
        const max = ''
        return {
            copyHtml:'',
            attributeType:{
                '正面':'tag-blue',
                '中性':'tag-orange',
                '负面':'tag-red',
            },//属性对应的class样式
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            downloadTips:'',//全部下载提示
			selectOption:[],
            selectOptionValue:[],//已选择下载
            page:1,//页码
            limit:20,//每页显示条数
            totalCount:'',//总页数
            pageUuid:[],//单分页所有的uuid
            uuids:[],//选择的newsid数组
            eventId:'',//事件ID
            eventName:'',//事件名称
            newsList:[],//新闻列表
            watch:true,//是否监听
            downLoadType:'',//下载类型
            nodata:false,//暂无数据
            // 舆情总览政府和主流报道列表的少选参数
            timeRange:[],
            planId:'',//方案ID
            timeType:0,//时间乐类型
            paixu:{
                timeAsc:"时间升序",
                timeDesc:"时间降序",
                sortDesc:"权重排序"
            },//排序字段
            sort:'timeDesc',//排序类型 desc是降序 asc是升序
            MediaPlatformList:[],//媒体列表
            platformType:['total'],//媒体选择
            mediaList:['全部','政府','媒体','个人','其他'],//媒体字段
            mediaLevel:'全部',//选择的媒体
            keywords:'',
            pubArea:'全国',//地区
            searchPlaceholder:['信息标题/内容/来源查询','请输入信息标题查询','请输入信息内容查询','请输入媒体来源查询'],//搜索提示语
            searchText:['全部','标题','内容','来源'],
            searchType:0,//搜素是的分类
            emotionList:['正面','中性','负面'],//情感字段
            emotion:['正面','中性','负面'],
            startDate:'',
            endDate:'',
            morenzhi:{},
        }
    },
    mounted() {
        let that = this;
        that.startDate = this.$route.query.startDate;
        that.endDate = this.$route.query.endDate;
        this.eventId = this.$route.query.id;
        this.eventName = this.$route.query.name;
        that.planId = that.$route.query.id;
        that.platformType = that.$route.query.type===null?['total']:[`${that.$route.query.type}`];
        that.timeRange = [that.startDate,that.endDate];
        that.timeType = 4;
        that.getNewsList();
    },
    created() {
        
    },
    methods: {
        //获取选中的方案
        getPlanvalue(e){
            this.mediaLevel = e;
            this.morenzhi = e;
            this.getNewsList(0);
        },
        // 获取新闻列表
        getNewsList (type) {
            let that = this;
            if(type === 0){//非翻页
                that.page = 1;
            }
            let datas = {
                eventId:that.eventId,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                startDate:that.startDate,
                endDate:that.endDate,
                pubArea:that.pubArea,
                emotion:that.emotion,
                sort:that.sort,
                searchType:that.searchType,
                keywords:that.keywords
            };
            that.uuids = [];
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('event/event/news-list',{data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.MediaPlatformList = r.data.platformDist;
                    let data = r.data;
                    // that.keywords = '';
                    if(data.list.length <= 0){//没有数据
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
                    that.newsList = data.list;//新闻列表赋值 
                    that.totalCount = data.total;
                    // that.newsSimHash = data.newsDetail.newsSimHash;
                    let pageUuid = [];
                    for(let i of data.list){
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    // 调用获取分析词和相似文章
                    that.getSimilarArticle(data.list);
                });
            })
        },
        // 获取分析词和相似文章
        getSimilarArticle (data) {
            let that = this;
            if(data.length <= 0){
                return;
            }
            let oldData = data;
            let simHash = [];
            let newsIds = [];
            let postDate = [];
            for(let i of data){
                simHash.push(i.newsSimHash);
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
            }
			let datas = {
			    startDate:that.$route.query.startDate,
			    endDate:that.$route.query.endDate
            };
            that.$api.post('monitor/info/news-simnum', {simHash:simHash,newsId:newsIds,sid:that.planId,data:datas,typefrom:'event'}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.simNum = datas[j].simNum;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
            that.$api.post('monitor/info/news-keyword', {postDate:postDate,newsId:newsIds}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
        },
        // 下拉筛选
        dropDownSelect (type,name) {
            let that = this;
            that.watch = false;
            if(type == 0){//媒体类别
                that.mediaLevel = name;
            }else if(type === 3){//排序类型
                that.sort = name;
            }
            that.getNewsList(0);
        },
        //选择城市回调
        citySelect (name) {
            let that = this;
            that.pubArea = name;
            this.getNewsList(0);
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            let checked = e.target.checked;
            that.uuids = [];
            if(checked == true){
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.uuids = [];
            }
        },
        // 下载
        downLoad (type) {
            let that = this;
            that.downLoadType = type;
			that.selectOptionValue = ['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_pubArea','news_posttime','media_pubArea'];
            let uuid = '';//全部下载为空
            if(type === 1){//选择下载
                uuid = that.uuids;
                if(uuid.length <= 0){
                    that.$utils.alertText('请选择需要下载的新闻');
                    return;
                }
            }else{
                if(that.newsList.length <= 0){
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
            }
			let data = {
			    uuid:uuid,
			    field:that.selectOptionValue,
			    type:that.$route.query.type,
                searchType:that.searchType,
                keywords:that.keywords,
                mediaLevel:that.mediaLevel,
                emotion:that.emotion,
			    platformType:that.platformType,
			    pubArea:that.pubArea,
			    startDate:that.startDate,
				// isFocus:that.$route.query.isFocus,
			    endDate:that.endDate
			};
			that.$parent.loadModal(true,'正在获取数据...');
			that.$api.post('monitor/info/download-before', {type:type,sid:that.eventId,typefrom:'event',data:data}, r => {
			    that.$utils.returnCode(r,function(){
			        that.$parent.showLoad = false;
			        that.downloadTips = r.msg;
					that.selectOption = r.data.fieldList;
			        that.$refs.downloadOption.showMaskFun();
			    });
			})
        },
        // 确定下载字段
        enterOption () {
            let that = this;
            if(that.selectOptionValue.length <= 0){
                that.$utils.alertText('请选择需要下载的字段');
                return;
            }
            let uuid = '';//全部下载为空
            let type = that.downLoadType;
            if(type === 1){//选择下载
                uuid = that.uuids;
            }
            let data = {
                uuid:uuid,
                field:that.selectOptionValue,
                type:that.$route.query.type,
                searchType:that.searchType,
                keywords:that.keywords,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                pubArea:that.pubArea,
                emotion:that.emotion,
                startDate:that.startDate,
                endDate:that.endDate
            };
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/info/download', {type:type,sid:that.eventId,typefrom:'event',data:data}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.selectOptionValue = [];
                    that.$refs.downloadOption.closeMask();
                    that.$parent.alertTips('已添加到我的下载列表');
                });
                if(r.code === -100){
                    that.$parent.showLoad = false;
                    that.$parent.alertTips(r.msg);
                }
            })
        },
        // 下载字段全选
        optionCheckAll (e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if(checked == true){
                let selectOption = that.selectOption;
                for(let i of selectOption){
                    that.selectOptionValue.push(i.type);
                }
            }else{
                that.selectOptionValue = [];
            }
            
        },
        // 翻页
        getTableData () {
            let that = this;
            that.getNewsList(1);
        },
        //收藏
        collectFn (index) {
            let that = this;
            let newsList = that.newsList;
            let sc = newsList[index].collectStatus;//获取收藏状态
            let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
            let uUid = newsList[index].newsId;
            let data = {
                type:1,
                typeId:[uUid]
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:data}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    sc = sc === 0 ? 1 : 0;
                    newsList[index].collectStatus = sc;
                    that.$utils.alertText('操作成功');
                });
            })
        },
		// 一键复制
		oneClickCopy (index){
			let that = this;
            let list = that.newsList[index];
            this.copyHtml = '';
            let copyFields = JSON.parse(sessionStorage.getItem('planStorage')).copyFields;
            for(let i in copyFields){
                this.copyHtml += copyFields[i]+':'+list[i]+'\n'
            }
			// this.copyHtml = '标题: '+list.originNewsTitle+'\n链接: '+list.newsUrl+'\n时间: '+list.newsPosttime+'\n来源:'+list.platformName+'\n作者: '+list.mediaName+'\n情感属性: '+list.newsEmotion+'\n分析词: '+list.keywords+'';
        },
        // 舆情总览政府和主流报道列表的特殊方案
        // 固定时间选择
        selectFixedTime (type) {//0是今天 1是昨天 2是近三天 3是近7天 4是自定义
            let that = this;
            that.dynamicTime(type);
            that.getNewsList(0);
            //that.getMediaLevel();
        },
        // 动态获取时间
		dynamicTime (type){
			let that = this;
			let nowTime = this.$utils.getNowDate();//今天时间
			let n = nowTime.split(' ')[1].split(':');//拆分当前时分秒
			let h = n[0]; 
			let m = n[1]; 
			let s = n[2]; 
			let min = '';
			let max = '';
			that.timeType = type;
			if(type != 4){//非自定义
			    if(type === 0){
			        min = nowTime.split(' ')[0] + ' ' + '00:00:00';
			        max = nowTime;
			    }else if(type === 1){
			        let yesterday = this.$utils.getBeforeDay(nowTime,1);//前一天
			        min = yesterday + ' ' + '00:00:00';
			        max = yesterday + ' ' + '23:59:59';
			    }else if(type === 2){
			        let ptd = this.$utils.getBeforeDay(nowTime,3);//前三天
			        // min = ptd + ' ' + h + ':' + m + ':' + s;
			        min = ptd + ' ' + '00:00:00';
			        max = nowTime;
			    }else if(type === 3){
			        let psd = this.$utils.getBeforeDay(nowTime,7);//前七天
			        // min = psd + ' ' + h + ':' + m + ':' + s;
			        min = psd + ' ' + '00:00:00';
			        max = nowTime;
			    }else if(type === 5){
			        let psd = this.$utils.getBeforeDay(nowTime,1);//24小时
			        min = psd + ' ' + h + ':' + m + ':' + s;
			        max = nowTime;
			    }else if(type === 6){
			        let day = JSON.parse(sessionStorage.getItem('planStorage')).adjustDay;
			        that.initialTime(day);
					return;
			    }
			    //进页面获取时间数据
			    that.startDate = min
                that.endDate = max;
			}else{
			    // let day = JSON.parse(sessionStorage.getItem('planStorage')).day;
			    that.initialTime(7);	
			}
        },
        // 获取当前时间和7天前时间
        initialTime(day) {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,day);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1], n2[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min,1);	
            this.endDate = this.$utils.dateConversion(max,1);
        },
        // 媒体类别数据
        getMediaLevel (){
            let that = this;
            let datas = {
                sid:that.eventId,
                startDate:that.startDate,
                endDate:that.endDate,
                searchWords:that.keywords,
                type:that.$route.query.type,
                searchType:that.searchType,
                emotion:that.emotion
            };
            that.$api.get('monitor/news-list/media-level',datas,r =>{
                that.$utils.returnCode(r,function(){
                    that.mediaDist = r.data;
                    that.getNewsList(0);
                });
            })
        },
        // 选择搜索分类
        searchSelect (value) {
            this.searchType = value;
        },
        // enter键搜索
        KeyUpEsc () {
            this.getNewsList(0);
        },
        disabledDate(time){
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() > new Date().getTime() || time.getTime() < number) return true;
            //if(time.getTime() > new Date().getTime()) return true;
        },
        //选择时间回调
        selectedDate () {
            let that = this;
            that.watch = false;
            that.startDate = this.$utils.dateConversion(this.timeRange[0],1);
            that.endDate = this.$utils.dateConversion(this.timeRange[1],1);
            let day = that.$utils.getDateDiff(that.startDate,that.endDate);
            if(day > that.$parent.timeSection){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天','',1500);
                return;
            }
            this.getNewsList(0);
        }
    },
    watch: {
        platformType(){
            let that = this;
            let len = that.platformType.length;
            if(that.platformType[0] === 'total' && len > 1){//选择非全部 
                that.platformType.splice(0,1);
            }else if(that.platformType[len-1] === 'total' && len > 1){
                that.platformType = ['total'];
            }
            that.getNewsList(0);
        },
        emotion (){
            this.getNewsList(0);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/productCenter/eventsInfomation.vue